var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTrendingVideos = function SvgTrendingVideos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "trending-videos_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1786",
    transform: "translate(-33 -620)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 596",
    width: 12,
    height: 14,
    rx: 2,
    transform: "translate(35 620)",
    fill: "url(#trending-videos_svg__a)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 597",
    transform: "translate(33 620)",
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1785",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 5",
    d: "M41.87 624.511a1.945 1.945 0 00-1.642.83l-.008-.01a2.901 2.901 0 00-.112.21 2.319 2.319 0 00-.2.536 3.113 3.113 0 00-.108.813v-.015a1.136 1.136 0 01-1.09 1.207 1.4 1.4 0 01-1.232-.807l-.923.469a2.239 2.239 0 002.189 1.318 1.905 1.905 0 001.96-1.724 2.421 2.421 0 00.062-.468v-.025-.065-.052.006a1.16 1.16 0 011.1-1.2 1.391 1.391 0 011.089.596l.925-.471a2.46 2.46 0 00-2.01-1.148"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 7",
    d: "M38.442 625.538a1.149 1.149 0 00-1.088 1.284 1.1 1.1 0 00.017.19l-.937.476a2.677 2.677 0 01-.114-.783 2.1 2.1 0 012.089-2.194 2.427 2.427 0 011.64.671l-1 .517a1.313 1.313 0 00-.61-.161"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 9",
    d: "M41.46 627.91a1.432 1.432 0 00.667.178 1.125 1.125 0 001.061-1.253 1.15 1.15 0 00-.1-.481l.914-.469a2.091 2.091 0 01.216.919 2.328 2.328 0 01-2.35 2.288 1.97 1.97 0 01-1.38-.637l.98-.531z"
  })))));
};
export default SvgTrendingVideos;